import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHamburgerSearch = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7373 5.25042C16.6298 5.25042 18.9746 7.59524 18.9746 10.4877C18.9746 11.6637 18.587 12.7492 17.9326 13.6233L21 16.6923L19.9419 17.7504L16.8729 14.683C15.9987 15.3374 14.9133 15.725 13.7373 15.725C10.8448 15.725 8.5 13.3802 8.5 10.4877C8.5 7.59524 10.8448 5.25042 13.7373 5.25042ZM8.22633 14.0012C8.87602 15.0287 9.81315 15.8743 10.9245 16.5007L1 16.5004V14.0004L8.22633 14.0012ZM13.7373 6.74679C11.6712 6.74679 9.99637 8.42166 9.99637 10.4877C9.99637 12.5538 11.6712 14.2286 13.7373 14.2286C15.8033 14.2286 17.4782 12.5538 17.4782 10.4877C17.4782 8.42166 15.8033 6.74679 13.7373 6.74679ZM7.42698 9.00069C7.31107 9.51031 7.25 10.0463 7.25 10.6055C7.25 10.9116 7.27063 11.2101 7.31055 11.5005L1 11.5004V9.00042L7.42698 9.00069ZM11.8254 4C10.5001 4.54672 9.37192 5.40276 8.56745 6.50049L1 6.50042V4.00042L11.8254 4Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHamburgerSearch);

export default ForwardRef;
